import uuid from 'react-uuid'

export class User {
  //#region Methods, Attributes, Properties
  private constructor() {
    this.setUserId()
  }

  private readonly storageKey = 'userid'
  private userId: undefined | string = undefined
  //#endregion Methods, Attributes, Properties

  //#region Singleton Pattern
  private static instance: User

  public static getInstance = (): User => {
    if (!User.instance) {
      User.instance = new User()
    }

    return User.instance
  }
  //#endregion Singleton Pattern

  //#region Public Methods
  public setUserId = (): void => {
    // if userid didn't stored in localstorage, new value is generated by uuid() function.
    let id: string

    id = localStorage.getItem(this.storageKey)!
    if (!id) {
      id = uuid()
      localStorage.setItem(this.storageKey, id)
    }

    // Setting userid
    this.userId = id
  }

  public getUserId = (): string | undefined => {
    if (!this.userId) {
      this.setUserId()
    }

    return this.userId
  }
  //#endregion Public Methods
}
